import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "portalId", "assignmentIds", "children", "textAlign", "tooltipPlacement"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAssignPlaylistUrl } from '../playlistAssignmentsRouting';
import UsageTracker from '../../../utils/UsageTracker';
import { useCallback } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssignPlaylistButton = _ref => {
  let {
      playlistId,
      portalId,
      assignmentIds,
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.assignPlaylist"
      }),
      textAlign = 'center',
      tooltipPlacement
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClick = useCallback(() => {
    UsageTracker.track('playlistInteraction', {
      action: assignmentIds ? 'playlist-due-date-update' : 'assign-playlist-clicked',
      playlistId,
      portalId
    });
  }, [assignmentIds, playlistId, portalId]);
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: tooltipPlacement,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.assignPlaylistTooltip"
    }),
    children: /*#__PURE__*/_jsx(RouterButton, Object.assign({
      onClick: handleClick,
      to: getAssignPlaylistUrl({
        playlistId,
        portalId,
        assignmentIds
      }),
      use: "tertiary-light"
    }, props, {
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        textAlign: textAlign,
        children: children
      })
    }))
  });
};